import { endpoints, host } from '@config/endpoints';
import request from './request';

export const exportIsco4AIChartData = async (urlDataAPI: any) => {
    const { exportType, type, isco4Codes, hubIds } = urlDataAPI;
    const { path, method } = endpoints.occupationAndSector.exportIsco4AIChartData;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { exportType, type, isco4Codes, hubIds },
            {
                responseType: "blob"
            },
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
